import React, { useEffect, useState } from "react";
import IsLoading from "../components/IsLoading";
import HasError from "../components/HasError";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import NoAcessPage from "./NoAccessPage";
import { fetchTestStations } from "../store/test";
import { fetchInfo } from "../store/information";
import AqiDisplay from "../components/AqiDisplay";

const DeviceTest = () => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) => state.login.accessToken);
  const isCompany = useSelector((state) => state.login.isCompany);
  useEffect(() => {
    const fetchData = () => {
      dispatch(fetchTestStations(isLoggedIn));
    };
    dispatch(fetchInfo());
    fetchData();

    const intervalId = setInterval(fetchData, 900000); // 900000 ms = 15 minutes

    return () => clearInterval(intervalId); // Cleanup interval on component unmount
  }, [dispatch]);

  const testStations = useSelector((state) => state.test);
  const testStationsData = testStations.testData.Test;
  const testStationsLoading = testStations.testLoading;
  const testStationsError = testStations.testError;
  const information = useSelector((state) => state.information);
  const informationData = information.informationData;
  const informationError = information.informationError;
  const informationLoading = information.informationLoading;
  const [allTestStations, setAllTestStations] = useState([]);

  const convertToJalali = (x) => {
    if (typeof x === "undefined") {
      return null; // or handle the error as appropriate
    }
    const A = x.slice(0, 10);
    const B = x.slice(11, 19);
    const C = new Date(A);
    const D = new Intl.DateTimeFormat("fa-IR").format(C);
    return D + " " + "(" + B + ")";
  };

  const navigate = useNavigate();
  const navigateToTestHistory = (routeUrl) => {
    const navigateUrl = "/test-data/" + routeUrl;
    navigate(navigateUrl);
  };

  const navigateToSATA2TestHistory = (routeUrl) => {
    const navigateUrl = "/SATA-test/" + routeUrl;
    navigate(navigateUrl);
  };

  useEffect(() => {
    if (!Array.isArray(informationData) || !Array.isArray(testStationsData)) {
      return;
    }

    const testInformation = informationData.filter(
      (station) => station.is_test
    );

    const modifiedTestStations = testInformation
      .map((information) => {
        const matchingStation = testStationsData.find(
          (station) =>
            station.device_id === information.device_id &&
            station.device === information.device
        );

        return matchingStation
          ? {
              ...information,
              ...matchingStation,
            }
          : null; // Return null if no matching station is found
      })
      .filter(Boolean); // Filter out any null values

    // Filter out test stations that are already in modifiedTestStations
    const testInformationWithoutDuplicates = testInformation.filter(
      (station) => {
        return !modifiedTestStations.some(
          (info) =>
            info.device === station.device &&
            info.device_id === station.device_id
        );
      }
    );

    // Combine the unique stations with the modified stations
    const combinedStations = [
      ...testInformationWithoutDuplicates,
      ...modifiedTestStations,
    ];

    // Sort by device_id
    combinedStations.sort((a, b) => a.device_id - b.device_id);

    // Update state
    setAllTestStations(combinedStations);
  }, [
    testStationsError,
    testStationsLoading,
    testStationsData,
    informationLoading,
    informationError,
    informationData,
  ]);

  const checkIsKit = (id) => {
    if (id && Array.isArray(informationData) && informationData.length > 0) {
      const kitDevices = informationData.find(
        (item) =>
          item.device === "SAPA" &&
          item.device_id === id &&
          item.is_kit === true
      );
      return !!kitDevices;
    }
  };

  if (!isCompany) {
    return <NoAcessPage />;
  } else if (testStationsLoading || informationLoading) {
    return <IsLoading />;
  } else if (testStationsError || informationError) {
    return <HasError />;
  } else if (allTestStations.length > 0) {
    return (
      <div className="container text-center mx-auto py-5">
        <h4 className="text-center mt-5">SAPA A</h4>
        <div className=" overflow-scroll">
          <table className="table table-responsive bg-light overflow-auto mx-auto">
            <thead>
              <tr>
                <th className="small p-1 p-md-3">ID</th>
                <th className="small p-1 p-md-3">AQI</th>
                <th className="small p-1 p-md-3">PM2.5</th>
                <th className="small p-1 p-md-3">PM10</th>
                <th className="small p-1 p-md-3">دما</th>
                <th className="small p-1 p-md-3">رطوبت</th>
                <th className="small p-1 p-md-3">زمان</th> <th></th>
              </tr>
            </thead>
            <tbody>
              {allTestStations &&
                allTestStations.map((data) =>
                  data.device === "OSPM" ? (
                    <tr key={data.slug}>
                      <td>
                        {data.device_id ? data.device_id : "-"} -
                        {data.device ? data.device : "-"}
                      </td>
                      {data.AQI !== undefined &&
                      data.AQI !== null &&
                      data.AQI >= 0 ? (
                        <td>{<AqiDisplay AQI={data.AQI} />}</td>
                      ) : (
                        <td>-</td>
                      )}
                      <td>
                        {data.pm25 || data.pm25 === 0 ? data.pm25 : "-"}
                        <sub>
                          {data.pm25 || data.pm25 === 0 ? (
                            <>
                              μg/m<sup>3</sup>
                            </>
                          ) : (
                            ""
                          )}
                        </sub>
                      </td>
                      <td>
                        {data.pm10 || data.pm10 === 0 ? data.pm10 : "-"}
                        <sub>
                          {data.pm10 || data.pm10 === 0 ? (
                            <>
                              μg/m<sup>3</sup>
                            </>
                          ) : (
                            ""
                          )}
                        </sub>
                      </td>
                      <td>
                        <sub>{data.temperature ? "℃" : ""} </sub>
                        {data.temperature || data.temperature === 0
                          ? data.temperature
                          : "-"}
                      </td>
                      <td>
                        <sub>{data.humidity ? " %RH" : ""} </sub>
                        {data.humidity || data.humidity === 0
                          ? data.humidity
                          : "-"}
                      </td>
                      <td>
                        {data.created_datetime
                          ? convertToJalali(data.created_datetime)
                          : "-"}
                      </td>
                      <td>
                        {data.created_datetime ? (
                          <div className="d-inline p-0">
                            <button
                              className="btn btn-primary m-0"
                              style={{ cursor: "pointer" }}
                              onClick={() => navigateToTestHistory(data.slug)}
                            >
                              تاریخچه
                            </button>
                          </div>
                        ) : (
                          ""
                        )}
                      </td>
                    </tr>
                  ) : (
                    ""
                  )
                )}
            </tbody>
          </table>
        </div>

        <hr className="my-5" />
        <h4 className="text-center">ESPS</h4>
        <div className=" overflow-scroll">
          <table className="table table-responsive bg-light overflow-auto mx-auto">
            <thead>
              <tr>
                <th className="small p-1 p-md-3">ID</th>
                <th className="small p-1 p-md-3">AQI</th>
                <th className="small p-1 p-md-3">PM2.5</th>
                <th className="small p-1 p-md-3">PM10</th>
                <th className="small p-1 p-md-3">دما</th>
                <th className="small p-1 p-md-3">رطوبت</th>
                <th className="small p-1 p-md-3">فشار</th>
                <th className="small p-1 p-md-3">زمان</th> <th></th>
              </tr>
            </thead>
            <tbody>
              {allTestStations &&
                allTestStations.map((data) =>
                  data.device === "ESPS" ? (
                    <tr key={data.slug}>
                      <td>
                        {data.device_id ? data.device_id : "-"} -
                        {data.device ? data.device : "-"}
                      </td>
                      {data.AQI !== undefined &&
                      data.AQI !== null &&
                      data.AQI >= 0 ? (
                        <td>
                          <AqiDisplay AQI={data.AQI} />
                        </td>
                      ) : (
                        <td>-</td>
                      )}
                      <td>
                        {data.pm25 || data.pm25 === 0 ? data.pm25 : "-"}
                        <sub>
                          {data.pm25 ? (
                            <>
                              μg/m<sup>3</sup>
                            </>
                          ) : (
                            ""
                          )}
                        </sub>
                      </td>
                      <td>
                        {data.pm10 || data.pm10 ? data.pm10 : "-"}
                        <sub>
                          {data.pm10 ? (
                            <>
                              μg/m<sup>3</sup>
                            </>
                          ) : (
                            ""
                          )}
                        </sub>
                      </td>
                      <td>
                        <sub>{data.temperature ? "℃" : ""} </sub>
                        {data.temperature || data.temperature === 0
                          ? data.temperature
                          : "-"}
                      </td>
                      <td>
                        <sub>
                          {data.humidity || data.humidity === 0 ? " %RH" : ""}
                        </sub>
                        {data.humidity || data.humidity === 0
                          ? data.humidity
                          : "-"}
                      </td>
                      <td>
                        {data.created_datetime
                          ? convertToJalali(data.created_datetime)
                          : "-"}
                      </td>
                      <td>
                        {data.created_datetime ? (
                          <div className="d-inline p-0">
                            <button
                              className="btn btn-primary m-0"
                              style={{ cursor: "pointer" }}
                              onClick={() => navigateToTestHistory(data.slug)}
                            >
                              تاریخچه
                            </button>
                          </div>
                        ) : (
                          ""
                        )}
                      </td>
                    </tr>
                  ) : (
                    ""
                  )
                )}
            </tbody>
          </table>
        </div>

        <hr className="my-5" />

        <h4 className="text-center">OSPL</h4>
        <div className=" overflow-scroll">
          <table className="table table-responsive bg-light overflow-auto mx-auto">
            <thead>
              <tr>
                <th className="small p-1 p-md-3">ID</th>
                <th className="small p-1 p-md-3">SPL</th>
                <th className="small p-1 p-md-3">رطوبت</th>
                <th className="small p-1 p-md-3">دما</th>
                <th className="small p-1 p-md-3">فشار</th>
                <th className="small p-1 p-md-3">زمان</th> <th></th>
              </tr>
            </thead>
            <tbody>
              {allTestStations &&
                allTestStations.map((data) =>
                  data.device === "OSPL" ? (
                    <tr className="border-1" key={data.slug}>
                      <td>
                        {data.device_id ? data.device_id : "-"} -
                        {data.device ? data.device : "-"}
                      </td>

                      {/* spl is pm10 in api */}
                      <td>
                        {data.pm10 || data.pm10 === 0 ? data.pm10 : "-"}
                        <span>
                          <sub>
                            {data.pm10 || data.pm10 === 0 ? " dB" : ""}{" "}
                          </sub>
                        </span>
                      </td>
                      <td>
                        <sub>
                          {data.humidity || data.humidity === 0 ? " %RH" : ""}
                        </sub>
                        {data.humidity || data.humidity === 0
                          ? data.humidity
                          : "-"}
                      </td>
                      <td>
                        <sub>
                          {data.temperature || data.temperature === 0
                            ? " ℃"
                            : ""}
                        </sub>
                        {data.temperature || data.temperature
                          ? data.temperature
                          : "-"}
                      </td>

                      {/* pressure_amb is no2 in api */}
                      <td>
                        <sub>{data.no2 || data.no2 === 0 ? " kPa" : ""}</sub>
                        {data.no2 || data.no2 === 0 ? data.no2 : "-"}
                      </td>
                      <td>
                        {data.created_datetime
                          ? convertToJalali(data.created_datetime)
                          : "-"}
                      </td>
                      <td>
                        {data.created_datetime ? (
                          <div className="d-inline p-0">
                            <button
                              className="btn btn-primary m-0"
                              style={{ cursor: "pointer" }}
                              onClick={() => navigateToTestHistory(data.slug)}
                            >
                              تاریخچه
                            </button>
                          </div>
                        ) : (
                          ""
                        )}
                      </td>
                    </tr>
                  ) : (
                    ""
                  )
                )}
            </tbody>
          </table>
        </div>

        <hr className="my-5" />

        <h4 className="text-center ">OPSGA</h4>
        <div className=" overflow-scroll">
          <table className="table table-responsive bg-light overflow-auto mx-auto">
            <thead>
              <tr>
                <th className="small p-1 p-md-3">ID</th>
                <th className="small p-1 p-md-3">O2</th>
                <th className="small p-1 p-md-3">CO</th>
                <th className="small p-1 p-md-3">NO</th>
                <th className="small p-1 p-md-3">NO2</th>
                <th className="small p-1 p-md-3">SO2</th>
                <th className="small p-1 p-md-3">Flow</th>
                <th className="small p-1 p-md-3">زمان</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {allTestStations &&
                allTestStations.map((data) =>
                  data.device === "OPSGA" ? (
                    <tr key={data.slug}>
                      <td>
                        {data.device_id ? data.device_id : "-"} -
                        {data.device ? data.device : "-"}
                      </td>

                      {/* o2 is o3 in api */}
                      <td>
                        <sub>{data.o2 || data.o2 === 0 ? "%Vol" : ""} </sub>
                        {data.o2 || data.o2 === 0 ? data.o2 : "-"}
                      </td>
                      <td>
                        <sub>{data.co || data.co === 0 ? "ppb" : ""} </sub>
                        {data.co || data.co === 0 ? data.co : "-"}
                      </td>

                      {/* NO is pm10 in api */}
                      <td>
                        <sub>{data.pm10 || data.pm10 === 0 ? "ppb" : ""} </sub>
                        {data.pm10 || data.pm10 === 0 ? data.pm10 : "-"}
                      </td>
                      <td>
                        <sub>{data.no2 || data.no2 ? "ppb" : ""} </sub>
                        {data.no2 || data.no2 ? data.no2 : "-"}
                      </td>
                      <td>
                        <sub>{data.so2 || data.so2 === 0 ? "ppb" : ""} </sub>
                        {data.so2 || data.so2 ? data.so2 : "-"}
                      </td>

                      {/* flow is pm25 in api */}
                      <td>
                        {data.pm25 || data.pm25 === 0 ? (
                          <sub>
                            m<sup>3</sup>/s
                          </sub>
                        ) : (
                          ""
                        )}

                        {data.pm25 || data.pm25 === 0 ? data.pm25 : "-"}
                      </td>
                      <td>
                        {data.created_datetime
                          ? convertToJalali(data.created_datetime)
                          : "-"}
                      </td>
                      <td>
                        {data.created_datetime ? (
                          <div className="d-inline p-0">
                            <button
                              className="btn btn-primary m-0"
                              style={{ cursor: "pointer" }}
                              onClick={() => navigateToTestHistory(data.slug)}
                            >
                              تاریخچه
                            </button>
                          </div>
                        ) : (
                          ""
                        )}
                      </td>
                    </tr>
                  ) : (
                    ""
                  )
                )}
            </tbody>
          </table>
        </div>

        {/* <hr className="my-5" /> */}
        {/* <h4 className="text-center ">BNZN</h4>
      <div className=" overflow-scroll">
        <table className="table table-responsive bg-light overflow-auto mx-auto">
          <thead>
            <tr>
              <th className="small p-1 p-md-3">ID</th>
              <th className="small p-1 p-md-3">B</th>
              <th className="small p-1 p-md-3">CO</th>
              <th className="small p-1 p-md-3">Temp</th>
              <th className="small p-1 p-md-3">press</th>
              <th className="small p-1 p-md-3">زمان</th> <th></th>
            </tr>
          </thead>
          <tbody>
            {!stationsLoading && !stationsError && BNZN.length > 0 ? (
              <tr key={BNZN[0].slug}>
                <td>
                  {BNZN[0].idStation ? BNZN[0].idStation : "-"} -
                  {BNZN[0].device ? BNZN[0].device : "-"}
                </td>
                <td>
                  <sub>{BNZN[0].B || BNZN[0].B === 0 ? "%RH" : ""} </sub>
                  {BNZN[0].B || BNZN[0].B === 0 ? BNZN[0].B : "-"}
                </td>
                <td>
                  <sub>{BNZN[0].CO || BNZN[0].CO === 0 ? "ppb" : ""} </sub>
                  {BNZN[0].CO || BNZN[0].CO ? BNZN[0].CO : "-"}
                </td>
                <td>
                  <sub>{BNZN[0].temp || BNZN[0].temp === 0 ? "℃" : ""} </sub>
                  {BNZN[0].temp || BNZN[0].temp === 0 ? BNZN[0].temp : "-"}
                </td>
                <td>
                  <sub>
                    {BNZN[0].press || BNZN[0].press === 0 ? "kPa" : ""}
                  </sub>
                  {BNZN[0].press || BNZN[0].press === 0 ? BNZN[0].press : "-"}
                </td>
                <td>
                  {BNZN[0].created_datetime
                    ? convertToJalali(BNZN[0].created_datetime)
                    : "-"}
                </td>
                <td></td>
              </tr>
            ) : (
              ""
            )}

            {testStations &&
              testStations.map((data) =>
                data.device === "BNZN" && data.device_id !== 101 ? (
                  <tr key={data.slug}>
                    <td>
                      {data.device_id ? data.device_id : "-"} -
                      {data.device ? data.device : "-"}
                    </td>
                    <td>
                      <sub>{data.B || data.B === 0 ? "%RH" : ""} </sub>
                      {data.B || data.B === 0 ? data.B : "-"}
                    </td>
                    <td>
                      <sub>{data.CO || data.CO === 0 ? "ppb" : ""} </sub>
                      {data.CO || data.CO ? data.CO : "-"}
                    </td>
                    <td>
                      <sub>{data.temp || data.temp === 0 ? "℃" : ""} </sub>
                      {data.temp || data.temp === 0 ? data.temp : "-"}
                    </td>
                    <td>
                      <sub>{data.press || data.press === 0 ? "kPa" : ""}</sub>
                      {data.press || data.press === 0 ? data.press : "-"}
                    </td>
                    <td>
                      {data.created_datetime
                        ? convertToJalali(data.created_datetime)
                        : "-"}
                    </td>
                    <td>
                      {data.created_datetime ? (
                        <div className="d-inline p-0">
                          <button
                            className="btn btn-primary m-0"
                            style={{ cursor: "pointer" }}
                            onClick={() => navigateToTestHistory(data.slug)}
                          >
                            تاریخچه
                          </button>
                        </div>
                      ) : (
                        ""
                      )}
                    </td>
                  </tr>
                ) : (
                  ""
                )
              )}
          </tbody>
        </table>
      </div> */}

        <hr className="my-5" />

        <h4 className="text-center">SAPA B</h4>
        <div className=" overflow-scroll">
          <table className="table table-responsive bg-light overflow-auto mx-auto">
            <thead>
              <tr>
                <th className="small p-1 p-md-3">ID</th>
                <th className="small p-1 p-md-3">AQI</th>
                <th className="small p-1 p-md-3">PM2.5</th>
                <th className="small p-1 p-md-3">PM10</th>
                <th className="small p-1 p-md-3">CO</th>
                <th className="small p-1 p-md-3">O3</th>
                <th className="small p-1 p-md-3">NO2</th>
                <th className="small p-1 p-md-3">SO2</th>
                <th className="small p-1 p-md-3">دما</th>
                <th className="small p-1 p-md-3">رطوبت</th>
                <th className="small p-1 p-md-3">زمان</th> <th></th>
              </tr>
            </thead>
            <tbody>
              {allTestStations &&
                allTestStations.map((data) =>
                  data.device === "SAPA" && !checkIsKit(data.device_id) ? (
                    <tr key={data.slug}>
                      <td>
                        {data.device_id ? data.device_id : "-"} -
                        {data.device ? data.device : "-"}
                      </td>
                      {data.AQI !== undefined &&
                      data.AQI !== null &&
                      data.AQI >= 0 ? (
                        <td>
                          <AqiDisplay AQI={data.AQI} />
                        </td>
                      ) : (
                        <td>-</td>
                      )}
                      <td>
                        <sub>
                          {data.pm25 || data.pm25 === 0 ? (
                            <>
                              μg/m<sup>3</sup>
                            </>
                          ) : (
                            ""
                          )}
                        </sub>
                        {data.pm25 || data.pm25 ? data.pm25 : "-"}
                      </td>
                      <td>
                        <sub>
                          {data.pm10 || data.pm10 === 0 ? (
                            <>
                              μg/m<sup>3</sup>
                            </>
                          ) : (
                            ""
                          )}
                        </sub>
                        {data.pm10 || data.pm10 === 0 ? data.pm10 : "-"}
                      </td>
                      <td>
                        <sub>{data.co || data.co ? "ppb" : ""} </sub>
                        {data.co || data.co === 0 ? data.co : "-"}
                      </td>
                      <td>
                        <sub>{data.o3 || data.o3 ? "ppb" : ""} </sub>
                        {data.o3 || data.o3 === 0 ? data.o3 : "-"}
                      </td>
                      <td>
                        <sub>{data.no2 || data.no2 ? "ppb" : ""} </sub>
                        {data.no2 || data.no2 === 0 ? data.no2 : "-"}
                      </td>
                      <td>
                        <sub>{data.so2 || data.so2 ? "ppb" : ""} </sub>
                        {data.so2 || data.so2 === 0 ? data.so2 : "-"}
                      </td>
                      <td>
                        <sub>
                          {data.temperature || data.temperature ? "℃" : ""}{" "}
                        </sub>
                        {data.temperature || data.temperature === 0
                          ? data.temperature
                          : "-"}
                      </td>
                      <td>
                        <sub>
                          {data.humidity || data.humidity ? " %RH" : ""}{" "}
                        </sub>
                        {data.humidity || data.humidity === 0
                          ? data.humidity
                          : "-"}
                      </td>
                      <td>
                        {data.created_datetime
                          ? convertToJalali(data.created_datetime)
                          : "-"}
                      </td>
                      <td>
                        {data.created_datetime ? (
                          <div className="d-inline p-0">
                            <button
                              className="btn btn-primary m-0"
                              style={{ cursor: "pointer" }}
                              onClick={() => navigateToTestHistory(data.slug)}
                            >
                              تاریخچه
                            </button>
                          </div>
                        ) : (
                          "-"
                        )}
                      </td>
                    </tr>
                  ) : (
                    ""
                  )
                )}
            </tbody>
          </table>
        </div>

        <hr className="my-5" />

        <h4 className="text-center">SATA</h4>
        <div className=" overflow-scroll">
          <table className="table table-responsive bg-light overflow-auto mx-auto">
            <thead>
              <tr>
                <th className="small p-1 p-md-3">ID</th>
                <th className="small p-1 p-md-3">سرعت باد</th>
                <th className="small p-1 p-md-3">جهت باد</th>
                <th className="small p-1 p-md-3">باران </th>
                <th className="small p-1 p-md-3">تابش خورشید </th>
                <th className="small p-1 p-md-3">دما </th>
                <th className="small p-1 p-md-3">رطوبت</th>
                <th className="small p-1 p-md-3">دمای خاک </th>
                <th className="small p-1 p-md-3">رطوبت خاک </th>
                <th className="small p-1 p-md-3">برف</th>
                <th className="small p-1 p-md-3">تبخیر</th>
                <th className="small p-1 p-md-3">ساعت و زمان</th> <th></th>
              </tr>
            </thead>
            <tbody>
              {allTestStations &&
                allTestStations.map((data) =>
                  data.device === "SATA2" ? (
                    <tr key={data.slug}>
                      <td>
                        {data.device_id ? data.device_id : "-"} -{" "}
                        {data.device ? data.device : "-"}
                      </td>

                      {data.wind_speed !== undefined &&
                      data.wind_speed !== null &&
                      data.wind_speed >= 0 ? (
                        <td>
                          {data.wind_speed} <sub>m/s</sub>
                        </td>
                      ) : (
                        <td>-</td>
                      )}

                      {data.wind_direction !== undefined &&
                      data.wind_direction !== null &&
                      data.wind_direction >= 0 ? (
                        <td>
                          {data.wind_direction} <sub>°</sub>
                        </td>
                      ) : (
                        <td>-</td>
                      )}

                      {data.wind_rain !== undefined &&
                      data.wind_rain !== null &&
                      data.wind_rain >= 0 ? (
                        <td>
                          {data.wind_rain} <sub>mm</sub>
                        </td>
                      ) : (
                        <td>-</td>
                      )}

                      {data.solar_radiation !== undefined &&
                      data.solar_radiation !== null &&
                      data.solar_radiation >= 0 ? (
                        <td>
                          {data.solar_radiation} <sub>W/m²</sub>
                        </td>
                      ) : (
                        <td>-</td>
                      )}

                      {data.temperature !== undefined &&
                      data.temperature !== null &&
                      data.temperature >= 0 ? (
                        <td>
                          {data.temperature} <sub>°C</sub>
                        </td>
                      ) : (
                        <td>-</td>
                      )}

                      {data.humidity !== undefined &&
                      data.humidity !== null &&
                      data.humidity >= 0 ? (
                        <td>
                          {data.humidity} <sub>%</sub>
                        </td>
                      ) : (
                        <td>-</td>
                      )}

                      {data.soil_temperature !== undefined &&
                      data.soil_temperature !== null &&
                      data.soil_temperature >= 0 ? (
                        <td>
                          {data.soil_temperature} <sub>°C</sub>
                        </td>
                      ) : (
                        <td>-</td>
                      )}

                      {data.soil_moisture !== undefined &&
                      data.soil_moisture !== null &&
                      data.soil_moisture >= 0 ? (
                        <td>
                          {data.soil_moisture} <sub>%</sub>
                        </td>
                      ) : (
                        <td>-</td>
                      )}

                      {data.snow !== undefined &&
                      data.snow !== null &&
                      data.snow >= 0 ? (
                        <td>
                          {data.snow} <sub>mm</sub>
                        </td>
                      ) : (
                        <td>-</td>
                      )}

                      {data.evaporation !== undefined &&
                      data.evaporation !== null &&
                      data.evaporation >= 0 ? (
                        <td>
                          {data.evaporation} <sub>mm</sub>
                        </td>
                      ) : (
                        <td>-</td>
                      )}

                      {data.ccreated_datetime ? (
                        <td className="ss01" dir="ltr">
                          {convertToJalali(data.ccreated_datetime)}
                        </td>
                      ) : data.created_datetime ? (
                        <td className="ss01" dir="ltr">
                          {convertToJalali(data.created_datetime)}
                        </td>
                      ) : (
                        <td>-</td>
                      )}

                      <td>
                        {data.created_datetime ? (
                          <div className="d-inline p-0">
                            <button
                              className="btn btn-primary m-0"
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                navigateToSATA2TestHistory(data.device_id)
                              }
                            >
                              تاریخچه
                            </button>
                          </div>
                        ) : (
                          ""
                        )}
                      </td>
                    </tr>
                  ) : null
                )}
            </tbody>
          </table>
        </div>

        <hr className="my-5" />

        <h4 className="text-center">SAPA C</h4>
        <div className=" overflow-scroll">
          <table className="table table-responsive bg-light overflow-auto mx-auto">
            <thead>
              <tr>
                <th className="small p-1 p-md-3">ID</th>
                <th className="small p-1 p-md-3">AQI</th>
                <th className="small p-1 p-md-3">PM2.5</th>
                <th className="small p-1 p-md-3">PM10</th>
                <th className="small p-1 p-md-3">CO</th>
                <th className="small p-1 p-md-3">O3</th>
                <th className="small p-1 p-md-3">NO2</th>
                <th className="small p-1 p-md-3">SO2</th>
                <th className="small p-1 p-md-3">دما</th>
                <th className="small p-1 p-md-3">رطوبت</th>
                <th className="small p-1 p-md-3">زمان</th> <th></th>
              </tr>
            </thead>
            <tbody>
              {allTestStations &&
                allTestStations.map((data) =>
                  data.device === "SAPA" && checkIsKit(data.device_id) ? (
                    <tr key={data.slug}>
                      <td>
                        {data.device_id ? data.device_id : "-"} -
                        {data.device ? data.device : "-"}
                      </td>
                      {data.AQI !== undefined &&
                      data.AQI !== null &&
                      data.AQI >= 0 ? (
                        <td>
                          <AqiDisplay AQI={data.AQI} />
                        </td>
                      ) : (
                        <td>-</td>
                      )}
                      <td>
                        <sub>
                          {data.pm25 || data.pm25 === 0 ? (
                            <>
                              μg/m<sup>3</sup>
                            </>
                          ) : (
                            ""
                          )}
                        </sub>
                        {data.pm25 || data.pm25 ? data.pm25 : "-"}
                      </td>
                      <td>
                        <sub>
                          {data.pm10 || data.pm10 === 0 ? (
                            <>
                              μg/m<sup>3</sup>
                            </>
                          ) : (
                            ""
                          )}
                        </sub>
                        {data.pm10 || data.pm10 === 0 ? data.pm10 : "-"}
                      </td>
                      <td>
                        <sub>{data.co || data.co ? "ppb" : ""} </sub>
                        {data.co || data.co === 0 ? data.co : "-"}
                      </td>
                      <td>
                        <sub>{data.o3 || data.o3 ? "ppb" : ""} </sub>
                        {data.o3 || data.o3 === 0 ? data.o3 : "-"}
                      </td>
                      <td>
                        <sub>{data.no2 || data.no2 ? "ppb" : ""} </sub>
                        {data.no2 || data.no2 === 0 ? data.no2 : "-"}
                      </td>
                      <td>
                        <sub>{data.so2 || data.so2 ? "ppb" : ""} </sub>
                        {data.so2 || data.so2 === 0 ? data.so2 : "-"}
                      </td>
                      <td>
                        <sub>
                          {data.temperature || data.temperature ? "℃" : ""}{" "}
                        </sub>
                        {data.temperature || data.temperature === 0
                          ? data.temperature
                          : "-"}
                      </td>
                      <td>
                        <sub>
                          {data.humidity || data.humidity ? " %RH" : ""}{" "}
                        </sub>
                        {data.humidity || data.humidity === 0
                          ? data.humidity
                          : "-"}
                      </td>
                      <td>
                        {data.created_datetime
                          ? convertToJalali(data.created_datetime)
                          : "-"}
                      </td>
                      <td>
                        {data.created_datetime ? (
                          <div className="d-inline p-0">
                            <button
                              className="btn btn-primary m-0"
                              style={{ cursor: "pointer" }}
                              onClick={() => navigateToTestHistory(data.slug)}
                            >
                              تاریخچه
                            </button>
                          </div>
                        ) : (
                          "-"
                        )}
                      </td>
                    </tr>
                  ) : (
                    ""
                  )
                )}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
};

export default DeviceTest;
